import { QueryAPI } from "../api";

export const useReport = () => {
	const sPSalesPerState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/SPSalesPerState", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const ePSalesPerState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/EPSalesPerState", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const dCSalesPerState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/DCSalesPerState", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportDCProductCountSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportDCProductCountSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportEPProductCountSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportEPProductCountSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportSPProductCountSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportSPProductCountSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportProductCommissionSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportProductCommissionSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const swSalesPerState = async () => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/SWSalesPerState", type: "GET" });
		return response ? response : null;
	};
	const coSalesPerState = async () => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/COSalesPerState", type: "GET" });
		return response ? response : null;
	};
	const querySPPurchaseDealerByCertNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QuerySPPurchaseDealerByCertNo", parameters: parameters });
		return response ? response : null;
	};
	const querySPPurchaseDealerByMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QuerySPPurchaseDealerByMSISDN", parameters: parameters });
		return response ? response : null;
	};
	return {
		swSalesPerState,
		coSalesPerState,
		sPSalesPerState,
		ePSalesPerState,
		dCSalesPerState,
		statisticalReportDCProductCountSales,
		statisticalReportEPProductCountSales,
		statisticalReportSPProductCountSales,
		statisticalReportProductCommissionSales,
		querySPPurchaseDealerByCertNo,
		querySPPurchaseDealerByMSISDN,
	};
};
